var LOCAL_HOSTNAMES = new Set(["localhost", "127.0.0.1", "0.0.0.0"]);
var shouldUpgradeToHttps = function (url) {
    return window.location.protocol === "https:" &&
        url.protocol === "http:" &&
        !LOCAL_HOSTNAMES.has(url.hostname);
};
export var normalizePublicFileUrl = function (filePath) {
    var path = filePath === null || filePath === void 0 ? void 0 : filePath.trim();
    if (!path) {
        return "";
    }
    try {
        var url = new URL(path);
        if (shouldUpgradeToHttps(url)) {
            url.protocol = "https:";
        }
        return url.toString();
    }
    catch (_a) {
        return encodeURI(path);
    }
};
export var buildPublicPdfPreviewUrl = function (filePath) {
    var url = normalizePublicFileUrl(filePath);
    if (!url) {
        return "";
    }
    return url.includes("#") ? "".concat(url, "&toolbar=0") : "".concat(url, "#toolbar=0");
};
